import React, { createContext, useState, useEffect } from "react";
// import schoolApi from "../api/schoolApi"; // Adjust path based on your project structure
import schoolApi from "../api/schoolApi"; // Adjust path based on your project structure

export const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [sessionYear, setSessionYear] = useState([]);
  const [selectedSessionId, setSelectedSessionId] = useState("");
  const [currentSessionId, setCurrentSessionId]= useState();

  useEffect(() => {
    async function fetchSessions() {
      try {
        const sessions = await schoolApi.fetchSessions();
        // if (sessions.success) {
        //   const currentDate = new Date().getDate();
        //   // Find the current session based on date range
        //   const currentSession = sessions.result?.find((sess) => {
        //     console.log(sess.startdate);
        //     console.log(sess.endDate);
            
        //     const startDate = new Date(sess.startdate).getDate();
        //     const endDate = new Date(sess.enddate);
        //     console.log(startDate);
        //     console.log(currentDate);
        //     console.log(endDate);
            
        //     return currentDate >= startDate && currentDate <= endDate;
        //   });
        //   console.log("currentSession =>",currentSession);
          
        //   setSessionYear(sessions.result);
        //   console.log("currentSession?.id@@=>", currentSession?.id);
        //   setSelectedSessionId(currentSession?.id);
        //   setCurrentSessionId(currentSession?.id)
        // }
 if (sessions.success) {
  const today = new Date().toISOString().split("T")[0]; // "2026-03-31"

  const currentSession = sessions.result?.find((sess) => {
    return today >= sess.startdate && today <= sess.enddate;
  });

  console.log("currentSession =>", currentSession);

  setSessionYear(sessions.result);
  setSelectedSessionId(currentSession?.id);
  setCurrentSessionId(currentSession?.id);
}
      } catch (error) {
        console.error("Error fetching sessions:", error);
      }
    }
    fetchSessions();
  }, []);

  return (
    <SessionContext.Provider
      value={{ sessionYear, selectedSessionId, setSelectedSessionId, currentSessionId  }}
    >
      {children}
    </SessionContext.Provider>
  );
};


// import React, { createContext, useState, useEffect } from "react";
// // import schoolApi from "../api/schoolApi"; // Adjust path based on your project structure
// import schoolApi from "../api/schoolApi"; // Adjust path based on your project structure

// export const SessionContext = createContext();

// export const SessionProvider = ({ children }) => {
//   const [sessionYear, setSessionYear] = useState([]);
//   const [selectedSessionId, setSelectedSessionId] = useState("");

//   useEffect(() => {
//     async function fetchSessions() {
//       try {
//         const sessions = await schoolApi.fetchSessions();
//         if (sessions.success) {
//           const currentDate = new Date();
//           // Find the current session based on date range
//           const currentSession = sessions.result?.find((sess) => {
//             const startDate = new Date(sess.startdate);
//             const endDate = new Date(sess.enddate);
//             return currentDate >= startDate && currentDate <= endDate;
//           });
//           setSessionYear(sessions.result);
//           console.log("currentSession?.id@@=>", currentSession?.id);
//           setSelectedSessionId(currentSession?.id);
//         }
//       } catch (error) {
//         console.error("Error fetching sessions:", error);
//       }
//     }
//     fetchSessions();
//   }, []);

//   return (
//     <SessionContext.Provider
//       value={{ sessionYear, selectedSessionId, setSelectedSessionId }}
//     >
//       {children}
//     </SessionContext.Provider>
//   );
// };
